<template>
  <div class="my_im_right">
     <div v-if="info.type === 'im'" class="my_im_top">
       {{info.name}}
     </div>
     <ul class="my_im_center" id="messageView">
       <li v-for="(item, index) in info.list" :key="item.id">
        <div v-if="index === 0" class="my_im_time">
         {{getTime(item.time)}}
        </div>
        <div v-else>
          <div v-if="item.time - info.list[index-1].time > 3*60" class="my_im_time">
            {{getTime(item.time)}}
          </div>
        </div>
         <div :class="[item.flow === 'in' ? 'my_im_receive': '', item.flow === 'out' ? 'my_im_send': '']">
           <div class="my_im_receive_pic">
             <img v-if="item.flow === 'in'" :src="info.pic" alt="头像">
             <img v-if="item.flow === 'out'" :src="currentUser.portrait" alt="头像">
           </div>
           <div class="my_im_receive_text">
             <div v-if="item.flow === 'out'" class="my_im_receive_state">
               <i v-show="item.state === 'login'" class="el-icon-loading"></i>
               <!-- <i v-show="item.state === 'success'" class="el-icon-success"></i> -->
               <i v-show="item.state === 'error'" class="el-icon-error"></i>
             </div>
             <p v-html="emojiFilter(item.payload.text, item.payload)"></p>
           </div>
         </div>
       </li>
     </ul>
     <div class="my_im_bottom">
       <ul class="my_im_control">
         <li class="lf">
           <el-popover
             placement="bottom"
             width="241"
             trigger="click">
             <emoji-view ref="EmotionB" @AppendInputValue="AppendTwoMessageText"></emoji-view>
             <p class="lf my_icon_box" slot="reference">
               <i class="my_icon biaoqing"></i><span class="my_icon_text">表情</span>
             </p>
           </el-popover>
         </li>
         <!-- <li v-if="info.type === 'im'" class="lf">
           <el-button type="text">聊天记录</el-button>
         </li> -->
       </ul>
       <div class="my_im_text">
         <el-input
           type="textarea"
           placeholder="请输入内容"
           v-model="textareaValue">
         </el-input>
       </div>
       <div class="my_im_btn">
         <button class="my_follow_btn" @click="createdMes()">发 送</button>
       </div>
     </div>
  </div>
</template>

<script>
import emoji from '../Public/emoji.vue'
export default {
  name: 'rightIm',
  components: {
    emojiView: emoji
  },
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentUser: {}, // 当前登陆用户信息
      textareaValue: '',
      EmotionList: ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭',
        '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱',
        '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘',
        '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼',
        '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒',
        '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹',
        '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引',
        '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手',
        '激动', '街舞', '献吻', '左太极', '右太极']
    }
  },
  created () {
    this.currentUser = this.$store.state.user.info
    this.currentUser.id = 'glga_' + this.currentUser.id
  },
  mounted () {
    // 绑定enter事件
    this.enterKeyup()
  },
  // 离开页面销毁事件
  destroyed () {
    // 销毁enter事件
    this.enterKeyupDestroyed()
  },
  methods: {
    // 校验表情
    emojiFilter (text, payload) {
      const vueThat = this
      if (Object.prototype.toString.call(text) === '[object String]') {
        return text.replace(/\[([^\]]+)\]/g, (words) => {
          words = words.replace('[', '')
          words = words.replace(']', '')
          const index = vueThat.EmotionList.indexOf(words)
          if (index !== -1) {
            return `<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif" style="width: 20px; height: 20px;margin: 0 1px">`
          } else {
            return words
          }
        })
      } else {
        let msg = ''
        // 判断是否为json字符串，try/catch主动抛出错误
        try {
          const str = JSON.parse(unescape(payload.data.replace(/\\u/g, '%u')))
          msg = `${str.data} <a href="${str.ext.url}" target="_blank">快速进入-></a>`
        } catch {
          msg = payload.data
        }
        return msg
      }
    },
    // 创建会话，发送消息
    createdMes () {
      const vueThat = this
      if (vueThat.textareaValue !== '') {
        const messageInfo = {
          payload: {
            text: ''
          },
          flow: 'out',
          state: 'login',
          time: 0
        }
        messageInfo.payload.text = vueThat.textareaValue
        messageInfo.time = Date.parse(new Date()) / 1000
        console.log(messageInfo)
        vueThat.info.list.push(messageInfo)
        vueThat.textareaValue = ''
        // 发送文本消息，Web 端与小程序端相同
        // 1. 创建消息实例，接口返回的实例可以上屏
        const message = vueThat.webIM.createTextMessage({
          to: vueThat.info.id + '',
          conversationType: vueThat.webIM.TYPES.CONV_C2C,
          payload: {
            text: messageInfo.payload.text
          }
        })
        // 2. 发送消息
        const promise = vueThat.webIM.sendMessage(message)
        promise.then(function (imResponse) {
          // 发送成功
          messageInfo.state = 'success'
          vueThat.scrollToBottom()
        }).catch(function (imError) {
          // 发送失败
          messageInfo.state = 'error'
          console.warn('sendMessage error:', imError)
        })
      } else {
        this.$message.error('发送内容不能为空')
        vueThat.textareaValue = ''
      }
    },
    // 二级回复表情选中后追加在input
    AppendTwoMessageText (EmotionChinese) {
      this.textareaValue += EmotionChinese
    },
    // 始终在对话框最底部
    scrollToBottom () {
      this.$nextTick(() => {
        const div = document.getElementById('messageView')
        div.scrollTop = div.scrollHeight
      })
    },
    // 监控回车键
    enterKey (event) {
      const componentName = this.$options.name
      if (componentName === 'rightIm') {
        const code = event.keyCode
          ? event.keyCode
          : event.which
            ? event.which
            : event.charCode
        if (code === 13) {
          if (this.info.id !== '') {
            const val = this.textareaValue.replace(/(^\s*)|(\s*$)/g, '')
            if (val.length === 0) {
              this.$message.error('发送内容不能为空')
              this.textareaValue = ''
            } else {
              this.createdMes()
            }
          }
        }
      }
    },
    // 消除回车键
    enterKeyupDestroyed () {
      document.removeEventListener('keyup', this.enterKey)
    },
    // 添加回车键
    enterKeyup () {
      console.log(11)
      document.addEventListener('keyup', this.enterKey)
    },
    // 过滤时间
    getTime (time) {
      return this.mycommon.getDate(time)
    },
    // 过滤链接
    ReplaceUrl (text) {
      const re = /(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[\w-./?%&id=]*)?)/gi
      const s = text.replace(re, function (a) {
        return '<a href="' + a + '" target=_blank>' + a + '</a>'
      })
      return s
    }
  }
}
</script>

<style>
</style>
